import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { Button as _Button } from "reactstrap";
export var Button = function (_a) {
  var children = _a.children,
      size = _a.size,
      className = _a.className,
      props = __rest(_a, ["children", "size", "className"]);

  return React.createElement(_Button, __assign({}, props, {
    className: classNames(className, {
      "btn-sm": size === "sm",
      "btn-lg": size === "lg"
    })
  }), children);
};